import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactOldPopup.TaxSection', {
    taxHeader: 'Tax',
    taxIdNumberLabel: 'Tax ID number',
    taxIdNumberPlaceholder: 'Enter Tax ID number',
    companyNumberLabel: 'Company Registration Number',
    companyNumberPlaceholder: 'Enter Company Registration Number',
    salesTaxLabel: 'Default sales tax',
    purchaseTax: 'Default purchase tax',
    dropdownPlaceholder: 'Select option',
});
